import Subscribe from './Popup/subscribe.vue'
const subscribe = {
    install: function(Vue) {
        Vue.component('subscribe', Subscribe)
    }
}
export default subscribe